<template>
<div>
<ContentHeader :title="title"  url="ProjectPeriods" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
  

<ClickEditInputText  title="Periyod İsmi" :value="item.name" valkey="name" @dataChanged="dataChanged" />

<ClickEditSwitch  title="Periyod Aktif" :value="item.activeperiod" valkey="activeperiod" @dataChanged="dataChanged" />


<ClickEditCalendar title="Periyod Başlangıcı" :value="item.startdate" valkey="startdate" @dataChanged="dataChanged" />

<ClickEditCalendar v-if="!$store.state.projects.project.is_periodic" title="Periyod Bitiş" :value="item.enddate" valkey="enddate" @dataChanged="dataChanged" />



<div class="grid">
<div class="col-12" v-for="flow in flows">

<template v-if="flow.flowexpenses.length">
  <ClickEditNumber  :title="flow.name+' dönem bedeli'" :value="flow.flowexpenses[0].price" valkey="price" @dataChanged="priceChanged($event,flow.id)" />

</template>
<template v-else>
   <ClickEditNumber  :title="flow.name+' dönem bedeli'" :value="0" valkey="price" @dataChanged="priceChanged($event,flow.id)" />

</template>

</div>
</div>

<template v-if="!item.previous_data_transfered && item.activeperiod">
  <div class="grid" >
    <div class="col-12"><p class="text-red-500"><b>Bu periyod aktif olarak işaretlendi. Soru listelerini güncelledikten sonra bu sayfaya dönüp önceki dönemden aktarılacak datayı belirleyin</b></p></div>
  </div>
</template>

<ClickEditSwitch  title="Önceki Dönem Verisini Taşı" :value="item.copy_previous_data" valkey="copy_previous_data" @dataChanged="dataChanged" v-if="item.activeperiod" />






<template v-if="item.copy_previous_data">
<div class="col-12">
<h4 class="text-primary">Önceki Dönemden Aktarılacak Veri</h4>
</div>
<div class="col-12">
<Dropdown v-model="selected_flow" :options="flows" optionLabel="name" class=" p-inputtext-sm ml-2"   @change="flowSelected" :filter="true" />

<Dropdown v-if="selected_flow" v-model="selected_inputfield" :options="inputfields" optionLabel="name"  class=" p-inputtext-sm ml-2"   @change="inputfieldSelected" :filter="true" :loading="loading_inputfields" />

<Dropdown v-if="selected_inputfield && selected_inputfield.type=='columns'" v-model="selected_inputfieldcolumn" :options="columns" optionLabel="name"  class=" p-inputtext-sm ml-2"   @change="columnSelected" :filter="true" :loading="loading_columns" />
</div>
<br/>
<div class="col-12">
<div class="flex justify-content-end flex-wrap " v-if="ready_to_add_field">
 <Button label="Yeni Alan Ekle" class=" p-button-primary p-button-outlined  p-button-sm" @click="addInputfield"></Button>
</div>
</div>

<div class="col-12" v-if="included_inputfields.length">

<DataTable 
:value="included_inputfields" 
responsiveLayout="scroll" 
class="p-datatable-suppliers" 
v-model:selection="selected_inputfields"
dataKey="id"
scrollable scrollHeight="70vh" 
:virtualScrollerOptions="{ itemSize: 50 }" 
:selectionMode="selectionmode"
:metaKeySelection="metaKey"
>

<template #header>
<div class="grid">

<div class="col-12 md:col-8 pt-1" v-if="!batchdeleteactive">
<Button label="Toplu Sil" class=" p-button-danger p-button-outlined  p-button-sm" @click="activateBatchDelete"></Button>
</div>

<div class="col-12 md:col-8 pt-1" v-if="batchdeleteactive">
<Button label="Sil" class=" p-button-info p-button-outlined  p-button-sm" @click="batchDelete"></Button>
<Button label="İptal" class=" p-button-danger p-button-outlined  p-button-sm ml-2" @click="cancelBatchDelete"></Button>
</div>


</div>
</template>
<Column selectionMode="multiple" headerStyle="width: 3rem" v-if="batchdeleteactive"></Column>


<Column  header="Aşama" sortable field="flow.name">
<template #body="slotProps"> 
<p>{{slotProps.data.flow.name}}</p>
</template>
</Column>

<Column  header="Soru" sortable field="inputfield.name">
<template #body="slotProps"> 
<p>{{slotProps.data.inputfield.name}}</p>
</template>
</Column>

<Column  header="Sütun" sortable field="inputfieldcolumn.name">
<template #body="slotProps"> 
<p v-if="slotProps.data.inputfieldcolumn">{{slotProps.data.inputfieldcolumn.name}}</p>
</template>
</Column>

<Column  header="Soru Tipi" sortable field="inputfield.type">
<template #body="slotProps"> 
<p>{{slotProps.data.inputfield.type}}</p>
</template>
</Column>

<Column  header="">
<template #body="slotProps"> 
 <Button  icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="removeFromList(slotProps.data.id)"></Button>
</template>
</Column>



</DataTable>

</div>



<div class="col-12">
  <hr>
</div>

</template>





<template v-if="!item.previous_data_transfered && item.activeperiod && item.copy_previous_data">
<div class="grid" >
<div class="col-3 md:col-2">
<p class="click_edit_value_title">Veri Taşımaya Hazır:</p>
</div> 
<div class="col-9 md:col-10 mt-4 pb-0 pt-1 mb-0">

<Button label="Tedarikçi Yükle" class=" p-button-primary p-button-outlined  p-button-sm" icon="pi pi-cloud-download" @click="showUploader"></Button>

<Button label="Yükleme Şablonu" class=" p-button-info p-button-outlined  p-button-sm ml-2"  icon="pi pi-cloud-upload" @click="downloadExcel"></Button>

</div>
</div>






<ProjectPeriodSupplierUploadModal :project="$store.state.projects.project" :period="item" ref="uploader"></ProjectPeriodSupplierUploadModal>
</template>








</template>


</div>
</template>

<script>
import ProjectPeriodSupplierUploadModal from "./ProjectPeriodSupplierUploadModal"
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import * as XLSX from 'xlsx'
export default {

  name: 'ProjectPeriod',

  data () {
    return {   
      languages:[],
      loading:true,
      item:null,
      metaKey:false,
      fields:[
        {
          title:"İsim",
          key:"name",
          type:"text",
          value:null,
          min_length:2,
          max_length:1000,
          is_required:true,
          has_error:false,
          error_message:null,
          show:true,
        },
        {
          title:"Önceki Dönem Verisini Taşı",
          key:"copy_previous_data",
          type:"switch",
          value:false,
          show:true,
        },        
        {
          title:"Başlangıç Tarihi",
          key:"start_date",
          type:"date",
          value:null,
          is_required:true,
          show:true,
        },     
        {
          title:"Bitiş Tarihi",
          key:"end_date",
          type:"date",
          value:null,
          is_required:false,
          show:true,
        },
      ],
      show_inputfields_selector:false,
      flows:[],
      inputfields:[],
      columns:[],
      loading_inputfields:false,
      loading_columns:false,
      selected_flow:null,
      selected_inputfield:null,
      selected_inputfieldcolumn:null,
      included_inputfields:[],
      ready_to_add_field:false, 
      selected_inputfields:[],
      batchdeleteactive:false,
      selectionmode:null,
      flows:[],
    }
  },
  components:{ProjectPeriodSupplierUploadModal},
  computed:{
    title()
    {
      if(this.$route.params.period_id)
      {
        return this.$store.state.languages.lang_phrases.proje_periyodu
      }
      return this.$store.state.languages.lang_phrases.yeni_proje_periyodu
    }
  },
  async mounted()
  {
    this.languages = await this.generalApiGetWithoutLoader("languages") 
    this.flows = await this.generalApiGetWithoutLoader("project_self_evaluation_flows/"+this.$route.params.id) 
    console.log("flows")
    console.log(this.flows)
    this.getData()
  },
  methods:{
    priceChanged(data,flow_id)
    {
      console.log(flow_id)
      if(data.value || data.value===0 )
      {         
        let formdata = new FormData()
        formdata.append("price",data.value)
        this.generalSubmission(formdata,"projectperiod/update_flow_price/"+flow_id+"/"+this.$route.params.period_id,this.afterpriceChanged) 
      }
      else
      {
        return false
      }
     
    },
    afterpriceChanged(response)
    {
      let flow = this.flows.findIndex((item)=>{return item.id == response.data.id})
      this.flows[flow] = response.data

    },
    activateBatchDelete()
    {
      this.batchdeleteactive = true
      this.selectionmode = "multiple"
    },
    cancelBatchDelete()
    {
      this.batchdeleteactive = false
      this.selectionmode = null
    },
    batchDelete()
    {
      //console.log(this.selected_inputfields)
      //return false
      let formdata = new FormData()
      let list = this.sanitizeArray(this.selected_inputfields)
      list = list.map((item)=>{return item.id})
      //console.log(list)
      //return false
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"projectperiod/delete_included_fields",this.afterbatchDelete) 
    },
    afterbatchDelete(response)
    {
      this.selected_inputfields = []
      this.included_inputfields = response.data
      this.cancelBatchDelete()
    },
    showUploader()
    {
      this.$refs.uploader.open()
    },
    async startCopyData()
    {
      return false
      let data = await this.generalApiGetWithoutLoader("projectperiod/clone_active_period_data/"+this.$route.params.period_id) 
      await this.showMessage("info","Veri Taşıma İşlemi Başladı","")
      this.item = data
      this.included_inputfields = await data.transferedfields

    },

    async getData()
    {
      console.log("getdata")
      let data = await this.generalApiGetWithoutLoader("projectperiod/"+this.$route.params.period_id)  
      this.item = data.period
      this.flows = data.flows
      console.log(data)
      this.included_inputfields = await data.period.transferedfields
      
      this.loading = await false
    },   

    
    async flowSelected()
    {
      this.selected_inputfield = null
      this.selected_inputfieldcolumn = null
      this.ready_to_add_field = false
      console.log("flowSelected")
      console.log(this.selected_flow)
      this.loading_inputfields = true
      this.inputfields = await this.generalApiGetWithoutLoader("questionlists/all_inputfields/"+this.selected_flow.questionlist_id) 
      this.inputfields.unshift({id:"all",name:"Hepsi"})
      this.loading_inputfields = false
    },
    async inputfieldSelected()
    {      

      if(this.selected_inputfield.id=="all")
      {
        this.getAllInputfields()
      }
      else
      {
        this.ready_to_add_field = false
        this.selected_inputfieldcolumn = null

        if(this.selected_inputfield.type=="columns")
        {
          this.loading_columns = true
          this.columns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+this.selected_inputfield.id) 
          this.columns = this.columns.filter((item)=>{return item.type=="text" || item.type=="number"})
          this.columns.unshift({id:"all",name:"Hepsi"})
          console.log(this.columns)
          this.loading_columns = false
        }
        else
        {
          this.ready_to_add_field = true
        }
      }
      
      
    },
    columnSelected()
    {
      if(this.selected_inputfieldcolumn.id=="all")
      {
        let int = 1
        for(let column of this.columns)
        {
          if(column.id!=="all")
          {
              let obj = {
                id:Math.floor(Date.now() / 10)+int,
                flow:this.selected_flow,
                inputfield_type:this.selected_inputfield.type,
                inputfield:this.selected_inputfield,  
                inputfieldcolumn:column
              }
              //this.included_inputfields.push(obj)
              int++
              let formdata = new FormData()
              formdata.append("included_inputfield",JSON.stringify(obj))
              this.silentSubmission(formdata,"projectperiod/store_included_field/"+this.$route.params.period_id,this.afteraddInputfield) 
          }
          
        }
        this.selected_flow = null
        this.selected_inputfield = null
        this.selected_inputfieldcolumn = null
        this.ready_to_add_field = false
      }
      else
      {
        this.ready_to_add_field = true
      }
    },

    async getAllInputfields()
    {
      let int = 1
      for(let inputfield of this.inputfields) 
      {
        if(inputfield.id !=="all")
        {
          //if column type
          if(inputfield.type=="columns")
          {
            let columns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+inputfield.id) 
            if(columns.length)
            {
              for(let column of columns)
              {
                if(column.type=="select" || column.type=="text" || column.type=="number")
                {
                  if(column.id!=="all")
                  {
                    let obj = {
                      id:Math.floor(Date.now() / 10)+int,
                      flow:this.selected_flow,
                      inputfield_type:inputfield.type,
                      inputfield:inputfield,  
                      inputfieldcolumn:column
                    }
                    //this.included_inputfields.push(obj)
                    int++                    
                    let formdata = new FormData()
                    formdata.append("included_inputfield",JSON.stringify(obj))
                    this.silentSubmission(formdata,"projectperiod/store_included_field/"+this.$route.params.period_id,this.afterBatchSubmission) 
                  }
                }
                
                
              }
            }
          }
          //if column type
          else
          {
            let obj = {
              id:Math.floor(Date.now() / 10)+int,
              flow:this.selected_flow,
              inputfield_type:inputfield.type,
              inputfield:inputfield,        
            }
            this.included_inputfields.push(obj)
            int++
            let formdata = new FormData()
            formdata.append("included_inputfield",JSON.stringify(obj))
            this.silentSubmission(formdata,"projectperiod/store_included_field/"+this.$route.params.period_id,this.afterBatchSubmission) 
          }

        }
        
      }
      setTimeout(()=>{
        this.selected_flow = null
        this.selected_inputfield = null
        this.selected_inputfieldcolumn = null
        this.ready_to_add_field = false
      })
      
    },
    afterBatchSubmission(response)
    {
      this.included_inputfields = response.data
    },
    addInputfield()
    {
      let obj = {
        id:Math.floor(Date.now() / 10),
        flow:this.selected_flow,
        inputfield_type:this.selected_inputfield.type,
        inputfield:this.selected_inputfield,        
      }
      if(this.selected_inputfield.type=="columns")
      {
        obj.inputfieldcolumn=this.selected_inputfieldcolumn
      }
      let formdata = new FormData()
      formdata.append("included_inputfield",JSON.stringify(obj))
      this.generalSubmission(formdata,"projectperiod/store_included_field/"+this.$route.params.period_id,this.afteraddInputfield)      

    },
    afteraddInputfield(response)
    {
      this.included_inputfields = response.data
      this.selected_flow = null
      this.selected_inputfield = null
      this.selected_inputfieldcolumn = null
      this.ready_to_add_field = false
    },
    removeFromList(id)
    {
      let formdata = new FormData()
      this.silentSubmission(formdata,"projectperiod/delete_included_field/"+id,this.afterremoveFromList) 
      
    },
    afterremoveFromList(response)
    {
      this.included_inputfields = this.included_inputfields.filter((item)=>{return item.id !== response.data})
    },

    dataChanged(data)
    {
      let formdata = new FormData()
      
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"projectperiod/update/"+this.item.id,this.afterdataChanged)
    },
    async afterdataChanged(response)
    {
      this.item =  response.data
      this.included_inputfields = await response.data.transferedfields
      //await this.$store.dispatch('projects/setProject',this.item)
      
    },
    async downloadExcel()
    {
      //return false
      let sheet = []
      let row = await [
      "Tedarikçi İsmi",
      "Tedarikçi Kodu(Markaya Özel)",
      "Yetkili İsmi",
      "Yetkili Email",
      "Yetkili Tel No(Tercihe Bağlı)",
      "Yetkili Görevi (Tercihe Bağlı)"
      ]
      await sheet.push(row)
      let row2 = await [
      "",
      "",
      "",
      "",
      "",
      "",
      ]
      await sheet.push(row2)


      let ws = await XLSX.utils.json_to_sheet(sheet)
      let wb = await XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(wb,ws,"Tedarikçiler")
      await XLSX.writeFile(wb,this.$store.state.projects.project.brand.name+" - "+this.item.name+"dönemi tedarikçileri.xls")
    }
  }
};
</script>

<style lang="css" scoped>
</style>